export function getIsTrackingAllowed() {
  const dataLayer = (typeof window !== 'undefined' && window.dataLayer) || []
  return dataLayer.some((entry) => {
    // gtag('consent', 'update', {...}) pushes an arguments object: [0]='consent', [1]='update', [2]=state
    if (!entry || entry[0] !== 'consent' || entry[1] !== 'update') return false
    const state = entry[2]
    return state && Object.keys(state).length > 0 && Object.values(state).every((value) => value === 'granted')
  })
}

export const GTM_EVENT_TYPES = {
  CAMPAIGN: 'Campaign',
  EXPERIENCE: 'Experience Page',
  FEATURED: 'Featured Event Card',
  HOME: 'Home Page',
  MASTERCHEF: 'Masterchef',
  MERCHANDISE: 'Merchandise',
  MY_MEALS: 'My Meals',
  PE_CAMPAIGN: 'Private Events Campaign',
  SEARCH_OPEN: 'Upcoming Events',
  SEARCH_PE: 'Private Event Search',
  SEARCH_REQUEST: 'Available by Request',
  SEARCH: 'Search Results',
  SIMILAR_EVENTS: 'Similar Events',
  USER: 'User Page',
  WISHLIST: 'Wishlist',
}
